<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
  <h2>{{'TOP.CONTRACTS' | translate}}</h2>
  @if (auth.isloggedIn) {
    <div>
      <form #fileUploadForm="ngForm">
        <input style="width: 400px;" type="text" class="form-control" placeholder="{{'CONTRACT.COMPANY' | translate }}" name="company" [(ngModel)]="contract.company"><br/>
        <input style="width: 400px;" type="text" class="form-control" placeholder="{{'CONTRACT.DESCRIPTION' | translate }}" name="description" [(ngModel)]="contract.description"><br/>
        <div class="form-group">
          <input type="file" id="fileUpload"  name="fileUpload" #fileUpload ng2FileSelect [uploader]="uploader" />
          <button type="button" class="btn btn-primary"
            (click)="upload(uploader)" [disabled]="!uploader.getNotUploadedItems().length">
            <span class="glyphicon glyphicon-upload"></span> Upload
          </button>
        </div>
      </form>
    </div>
  }
  <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'contract'" [downloadButton]=true [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="['','company','description']" (onDeleteQuery)="deleteContract($event)"></ntr-datatable>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.LOADING' | translate}}...</p>
</ngx-spinner>